import React, { useState } from "react";

function LosGatosShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Our Los Gatos Junk Removal Services</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="pb-0">
          We specialize in a wide range of junk removal services tailored to fit
          your needs. Whether you need to clear out household junk, remove old
          appliances, or tackle a commercial property cleanout, Junk Droid
          offers efficient solutions that work for you.
          <ul>
            <li>Estate cleanouts and office furniture removal</li>
            <li>Construction debris removal and demolition services</li>
            <li>E-waste disposal for safe handling of old electronics</li>
            <li>Furniture donation and removal of unwanted furniture</li>
            <li>Garbage removal and junk hauling services</li>
            <li>Hot tub removal and large item pickups</li>
          </ul>
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <h3>Convenient and Efficient Junk Removal</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p className="pt-3 pb-0">
              Whether you're clearing out an old mattress, dealing with a pile
              of unwanted scrap metal Junk Droid has you covered. We offer:
            </p>
            <ul>
              <li>Same-day service and next-day service</li>
              <li>Affordable prices with reasonable pricing options</li>
              <li>
                Friendly, professional team members who handle all the heavy
                lifting
              </li>
              <li>
                Free Junk Removal and transparent pricing for hassle-free
                service
              </li>
            </ul>
          </div>

          <h3>Serving Los Gatos and Surrounding Areas</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="pt-0 junk-santa-desc milpitas-list">
            <p className="junk-santa-desc resid-rmv">
              Junk Droid proudly serves Los Gatos, Santa Clara County, and
              nearby cities such as:
            </p>
            <ul>
              <li>San Jose, CA</li>
              <li>Mountain View</li>
              <li>Palo Alto</li>
              <li>Redwood City</li>
              <li>Menlo Park</li>
              <li>Los Altos Hills</li>
              <li>Cambrian Park</li>
              <li>Lexington Hills</li>
            </ul>
            <p className="pt-0">
              If you're in need of junk removal in Los Gatos, CA, or nearby
              areas, you can count on Junk Droid to provide fast, professional,
              and eco-friendly junk removal services.
            </p>
          </div>

          <h3>Call for a Free Quote</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              Ready to reclaim your space? Call Junk Droid today at{" "}
              <a href="tel:+4085397261">(408) 539-7261</a> for a free estimate
              or to schedule your same-day junk removal. We are here to make
              your junk removal process as easy as possible with affordable
              prices, high-quality service, and responsible disposal solutions.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default LosGatosShowHide;
